import { render, staticRenderFns } from "./FinalPriceDescription.vue?vue&type=template&id=0a3591a5&"
import script from "./FinalPriceDescription.vue?vue&type=script&lang=js&"
export * from "./FinalPriceDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports